var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3468 17.1492L33.3682 17.1762L33.3931 17.2001C35.5777 19.2933 35.6017 22.885 33.3763 25.2306L32.5039 26.1501L24.7917 34.2786L16.8687 26.1477L16.0069 25.2393C13.987 22.8885 14.0112 19.2779 15.9986 17.1832L16.0141 17.1669L16.028 17.1492C17.0012 15.9183 18.3656 15.5 19.5618 15.5C20.9877 15.5 22.3461 15.9254 23.3137 17.1492L23.345 17.1888L23.3836 17.2213L24.4742 18.1409L24.8347 18.4448L25.1592 18.1028L26.0317 17.1832L26.0472 17.1669L26.0612 17.1492C27.0287 15.9254 28.3872 15.5 29.813 15.5C31.2154 15.5 32.3675 15.9105 33.3468 17.1492Z",
    stroke: "#434343"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.0661d8da3d0dd9b9f0f6ef21bb87c53c.svg";
export { ForwardRef as ReactComponent };